import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tech-dairy',
  templateUrl: './tech-dairy.component.html',
  styleUrls: ['./tech-dairy.component.css'],
})
export class TechDairyComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
